<template>
  <v-select
    :rules="rules"
    v-bind="[fieldProps, $attrs]"
    :loading="loading"
    :items="items"
    name="category"
    placeholder="Tipo"
    :menu-props="menuProps"
  >
  </v-select>
</template>

<script>
import { requiredValidation } from "../validations/requiredValidation";
import { mixin } from "./mixin";

const _config = {
  mod: "categories",
};

const _data = {
  loading: true,
  rules: [requiredValidation("Selecione o tipo do imovel.")],
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    menuProps() {
      const height = window.innerHeight - 200;

      return {
        maxHeight: height,
        closeOnContentClick: true,
      };
    },
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  created() {
    this.$rest(_config.mod)
      .get()
      .finally(() => (this.loading = false));
  },
  mixins: [mixin],
};
</script>
